export default "__VITE_ASSET__dec57589__"